import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import {
  createTeamMember,
  getAllTeamMembers,
  getTeamMemberByID,
  TeamMemberImageUpload,
  updateTeamMember,
} from "./services/teamMember.services";
import { clearTeamMemberDetails } from "./teamMemberSlice";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { RxCross1 } from "react-icons/rx";
import FormImageUploadMorden from "../../components/formFields/formImageUploadMorden";
import FormTextArea from "../../components/formFields/FormTextArea";

const CreateTeamMember: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  // const location = useLocation();
  // const TeamMemberID = location.state?.TeamMemberID;
  const TeamMemberID = useAppSelector((state) => state.muidrawer.data);
  const TeamMemberDetail = useAppSelector(
    (state) => state.teammember.TeamMemberDetail
  );
  const loading = useAppSelector((state) => state.teammember.formLoading);
  const [formKey, setFormKey] = React.useState(1);

  useEffect(() => {
    if (TeamMemberID) {
      dispatch(getTeamMemberByID(TeamMemberID));
    }
    return () => {
      dispatch(clearTeamMemberDetails());
    };
  }, [TeamMemberID]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [TeamMemberDetail]);

  const handleSubmit = async (values: any) => {
    const formData = {
      Name: values?.Name ? values?.Name : "",
      Title: values?.Title ? values?.Title : "",
      Email: values?.Email ? values?.Email : "",
      Message: values?.Message ? values?.Message : "",
      PhoneNo: values?.PhoneNo ? values?.PhoneNo : "",
      Whatsapp: values?.Whatsapp ? values?.Whatsapp : "",
      Linkedin: values?.Linkedin ? values?.Linkedin : "",
      Skype: values?.Skype ? values?.Skype : "",
      IsActive: values?.IsActive === 1,
    };
    const ImageData = new FormData();
    const Image =
      values?.Image &&
      typeof values?.Image !== "string" &&
      Array.isArray(values?.Image) &&
      values?.Image?.length > 0
        ? values.Image[0].getRawFile()
        : "";

    try {
      if (TeamMemberID) {
        const editPayload = {
          ...formData,
          ID: TeamMemberID,
        };

        const response = await dispatch(updateTeamMember(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());

          if (
            values?.Image &&
            typeof values?.Image !== "string" &&
            Array.isArray(values?.Image) &&
            values?.Image?.length > 0
          ) {
            ImageData.append("Image", Image);
            ImageData.append("ID", TeamMemberID);
            await dispatch(TeamMemberImageUpload(ImageData));
          }
          dispatch(getAllTeamMembers());
          dispatch(clearTeamMemberDetails());
        }
      } else {
        const response = await dispatch(createTeamMember(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          if (
            values?.Image &&
            typeof values?.Image !== "string" &&
            Array.isArray(values?.Image) &&
            values?.Image?.length > 0 &&
            response?.payload?.Data?.ID
          ) {
            ImageData.append("Image", Image);

            ImageData.append("ID", response?.payload?.Data?.ID);
            await dispatch(TeamMemberImageUpload(ImageData));
          }
          dispatch(getAllTeamMembers());
          dispatch(clearTeamMemberDetails());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div>
        <Form
          key={formKey}
          onSubmit={handleSubmit}
          initialValues={TeamMemberDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <GridLayout
                gap={{ rows: 10 }}
                cols={[{ width: "50%" }, { width: "50%" }]}
              >
                <GridLayoutItem className="master-drawer-header" colSpan={2}>
                  <Typography.h4 className="m-0">
                    {TeamMemberID ? "Update TeamMember" : "Create TeamMember"}
                  </Typography.h4>
                  <Button
                    type="button"
                    fillMode={"flat"}
                    themeColor={"dark"}
                    style={{ marginRight: 4 }}
                    onClick={() => dispatch(closed())}
                  >
                    <RxCross1 />
                  </Button>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="Name"
                    label="Name"
                    placeholder="Team Member Name"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                  <Field
                    name="Title"
                    label="Title"
                    placeholder="Title"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                  <Field
                    justifyContent="start"
                    name="Image"
                    label="Image"
                    type="file"
                    accept="image/*"
                    alternateName="Team Member Image"
                    component={FormImageUploadMorden}
                  />
                </GridLayoutItem>
                <GridLayoutItem className="px-2">
                  <Field
                    name="PhoneNo"
                    label="Phone No."
                    placeholder="Phone No"
                    component={FormTextField}
                  />
                  <Field
                    name="Email"
                    label="Email ID"
                    placeholder="Email ID"
                    component={FormTextField}
                  />
                  <Field
                    name="Whatsapp"
                    label="Whatsapp"
                    placeholder="Whatsapp"
                    component={FormTextField}
                  />
                  <Field
                    name="Linkedin"
                    label="Linkedin"
                    placeholder="Linkedin"
                    component={FormTextField}
                  />
                  <Field
                    name="Skype"
                    label="Skype"
                    placeholder="Skype"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2}>
                  <Field
                    name="Message"
                    label="Message"
                    placeholder="Title"
                    component={FormTextArea}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2}>
                  <Field
                    name={`IsActive`}
                    label="Status"
                    placeholder="i.e. Active"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={STATUSARRAY?.map((status: any) => {
                      return {
                        value: status?.value,
                        label: status?.label,
                      };
                    })}
                  />
                </GridLayoutItem>

                <GridLayoutItem
                  colSpan={2}
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <div>
                    <ButtonWithLoading
                      label={TeamMemberID ? "Update" : "Create"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                    <Button
                      type="button"
                      fillMode={"outline"}
                      themeColor={"primary"}
                      style={{ marginLeft: 10 }}
                      onClick={() => dispatch(closed())}
                    >
                      Cancel
                    </Button>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </FormElement>
          )}
        />
      </div>
    </>
  );
};

export default CreateTeamMember;
